var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPhoneinline = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "m15.334 11.334.166.166c.32.32.5.754.5 1.207V14q0 2-1 2C7 16 0 9 0 1q0-1 2-1h1.293C3.746 0 4.18.18 4.5.5l.166.166a2 2 0 0 1 .483.782l.685 2.055a1 1 0 0 1-.148.916L4.5 6l5.5 5.5 1.58-1.186a1 1 0 0 1 .917-.148l2.055.685a2 2 0 0 1 .782.483"
})));
export default SvgPhoneinline;